import { Icon } from '@iconify/react';
import { Seo } from '../lib/seo';
import { useSite } from '../lib/site-context';

export function PrivacyPage() {
  const { site } = useSite();
  const siteName = site.settings['site.name'] || 'A3GS Tec';

  return (
    <>
      <Seo
        title={`Política de Privacidade | ${siteName}`}
        description={`Diretrizes de proteção e privacidade de dados em conformidade com a LGPD da ${siteName}.`}
        path="/privacidade"
      />

      <main className="section">
        <div className="container" style={{ maxWidth: '900px' }}>
          <div className="section-heading" style={{ textAlign: 'left', marginBottom: '32px' }}>
            <span className="section-tag">SEGURANÇA & LGPD</span>
            <h1>Política de Privacidade</h1>
            <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
          </div>

          <article className="prose-card" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <section>
              <h2>1. Coleta de Informações</h2>
              <p className="muted">
                Coletamos dados fornecidos voluntariamente por meio do formulário de contato (nome, e-mail, telefone e
                mensagem) e da inscrição na newsletter. Dados técnicos de navegação (como endereço IP anonimizado, tipo de
                navegador e páginas acessadas) são processados na borda para segurança e auditoria.
              </p>
            </section>

            <section>
              <h2>2. Finalidade do Tratamento</h2>
              <ul className="check-list">
                <li>Responder a orçamentos e solicitações comerciais;</li>
                <li>Garantir a integridade, disponibilidade e segurança das aplicações;</li>
                <li>Cumprir obrigações legais e regulatórias vigentes.</li>
              </ul>
            </section>

            <section>
              <h2>3. Armazenamento e Segurança</h2>
              <p className="muted">
                Os dados são armazenados em infraestrutura de borda (Cloudflare D1 / Bancos Relacionais) protegida por
                criptografia TLS 1.3 em trânsito e controle restrito de acesso por credenciais autenticadas. Não
                comercializamos dados com terceiros.
              </p>
            </section>

            <section>
              <h2>4. Direitos do Titular (LGPD)</h2>
              <p className="muted">
                Em conformidade com a LGPD (Lei nº 13.709/2018), você pode a qualquer momento solicitar confirmação da
                existência de tratamento, correção de dados incompletos ou exclusão de suas informações de nossa base.
              </p>
            </section>

            <section>
              <h2>5. Encarregado de Dados (DPO)</h2>
              <p className="muted">
                Para exercer seus direitos de privacidade, entre em contato com nosso time de segurança pelo e-mail:{' '}
                <strong>{site.settings['site.email'] || 'contato@a3gs.com.br'}</strong>.
              </p>
            </section>
          </article>
        </div>
      </main>
    </>
  );
}